import React, { Component } from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../../src/lib/component-base';
import Icon from '../../../../../../src/components/lib/Icon';

@componentBase('SubscriptionService')
export default class SubscriptionService extends Component {
  static propTypes = {
    serviceImageSrc: PropTypes.string,
    serviceUnlocked: PropTypes.bool,
    serviceTitle: PropTypes.string,
    serviceLink: PropTypes.string,
    serviceSubtitle: PropTypes.string,
  };

  render() {
    const backgroundClass = this.props.serviceUnlocked ? 'unlocked' : 'standard';

    let anchorStyle = 'service-section-head';
    if (!this.props.serviceLink) {
      // Used only for the case of 'Better Ads', removes highlighting on hover
      anchorStyle = `${anchorStyle} betterAdsLinkStyle`;
    }

    return (
      <a className={`${anchorStyle} row-eq-height`} href={this.props.serviceLink} style={{ padding: '10px 0', minHeight: '60px' }}>
        <div className={`col-xs-2 col-sm-1 serviceSectionIcon-${backgroundClass}`}>
          <Icon className='serviceIcon' src={this.props.serviceImageSrc} />
        </div>
        <div className={`col-xs-10 col-sm-11 serviceSectionDescription-${backgroundClass}`}>
          <p className='title'>{this.props.serviceTitle}</p>
          <p className='subtitle'>{this.props.serviceSubtitle}</p>
        </div>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Account/components/Subscription/Success/children/SubscriptionService.js